<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetSidebarRates } from '~/components/widget/sidebar-rates'
import { WidgetVacanciesListMeiliSearch } from '~/components/widget/vacancies/list'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetSeoContent, WidgetSeoHeroBanner } from '~/components/widget/seo'
import { WidgetFaqList } from '~/components/widget/faq-list'

const { pathWithoutLocale } = useLocalizedPath()
const { t } = useI18n()

const breadcrumbs = computed(() => [{ title: t('common.vacancies'), url: '/vacancies' }])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <SidebarBlock variant="white" :heading-text="$t('common.exchange_rates')">
              <WidgetSidebarRates />
            </SidebarBlock>
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="space-y-5" role="main">
          <WidgetSeoHeroBanner
            image="/images/photostock/vacancies.png"
            illustration="vacancies"
            backdrop="tunduk"
          />
          <WidgetVacanciesListMeiliSearch :query-params="{ per_page: '20' }" />
          <WidgetSeoContent position="bottom" />
          <WidgetFaqList
            :query-params="{
              'filter[faqable_url]': pathWithoutLocale
            }"
          />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
